import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Dispatch, SetStateAction } from "react";

export type MonthsOfYearProps = {
  onChange: Dispatch<SetStateAction<number[]>>;
  months: number[];
};

export type MonthsOfYearType = {
  value: number;
  isCheck: boolean;
};

const emptyMonth: number[] = [];

export const MonthsOfYear = ({ onChange, months = emptyMonth }: MonthsOfYearProps) => {
  const mapMonths = syncMonthsOfYear(months);
  const changeValue = (idx: number) => {
    const newDaysOfMonth = mapMonths.reduce((preValue: number[], currentValue, index) => {
      if ((index === idx && !currentValue.isCheck) || (index !== idx && currentValue.isCheck)) {
        return [...preValue, currentValue.value];
      }
      return preValue;
    }, []);
    onChange(newDaysOfMonth);
  };

  return (
    <div className="flex flex-wrap gap-2">
      {mapMonths.map((item, idx) => (
        <div className="flex items-center space-x-2" key={`month-of-year-${item.value}-${idx}`}>
          <Checkbox
            checked={item.isCheck}
            onClick={() => changeValue(idx)}
            value={item.value}
            id={`month-of-year-${item.value}-${idx}`}
          />
          <Label htmlFor={`month-of-year-${item.value}-${idx}`}>{item.value}</Label>
        </div>
      ))}
    </div>
  );
};

export const syncMonthsOfYear = (list: number[]): MonthsOfYearType[] => {
  const arrayDay = [];
  for (let i = 1; i <= 12; i++) {
    arrayDay.push({ value: i, isCheck: list.includes(i) });
  }
  return arrayDay;
};
